import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Luggage(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M18.48 4.053a3.632 3.632 0 011.23-1.416C20.316 2.234 21.076 2 22 2a1 1 0 110 2c-.575 0-.94.14-1.18.3-.542.362-.803 1.077-.82 1.706V15a2.997 2.997 0 01-1.385 2.529 3 3 0 11-5.444.471H8.829a3 3 0 11-5.659 0H3a1 1 0 110-2h1v-4a3 3 0 013-3V8a2 2 0 012-2h3a2 2 0 012 2v1a3 3 0 013 3v4a1 1 0 001-1V6a4.473 4.473 0 01.48-1.947zM6 16h9v-4a1 1 0 00-1-1H7a1 1 0 00-1 1v4zm0 2a1 1 0 100 2 1 1 0 000-2zm9 1a1 1 0 112 0 1 1 0 01-2 0zM12 9V8H9v1h3z",
    clipRule: "evenodd"
  }));
}

export default Luggage;